'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _TypicalResponseTime = require('../../typical-response-time/records/TypicalResponseTime');

var _TypicalResponseTime2 = _interopRequireDefault(_TypicalResponseTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TypicalResponseTimeMessageMetadata = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.TYPICAL_RESPONSE_TIME), _defineProperty(_Record, 'text', ''), _defineProperty(_Record, 'typicalResponseTime', (0, _TypicalResponseTime2.default)()), _Record), 'TypicalResponseTimeMessageMetadata');

exports.default = TypicalResponseTimeMessageMetadata;
module.exports = exports['default'];